import styled from 'styled-components';
import { variables } from '../../../../styles/variables';
import { SubjectCardFormElementFontStyle } from '../../../../styles/sharedUIElemStyles';
import { Input } from 'react-inv-forms';

const CustomInput = styled(Input)`
  max-height: 3.8rem;
  input.ant-input {
    padding: 0;
    ${SubjectCardFormElementFontStyle};
  }
  &::placeholder {
    opacity: 0.3;
  }  
  &:hover {
    border: 1px solid ${variables.colorDecorator};
  }
  &.ant-input:focus, &.ant-input-focused {
    border-color: ${variables.colorDecorator};
    box-shadow: 0 0 0 2px rgba(139,35,29, 0.1);
  }
  .anticon.ant-input-clear-icon {
    font-size: 1.6rem;
  }
`;

export {
  CustomInput as Input,
};